import React from 'react';
import jquery from "jquery";

class Modal extends React.Component{
  
    constructor(props) {
      super(props);
      this.show = this.show.bind(this);
    }
  
    show() {
      jquery(this.refs.myModal).modal();
    }

    static defaultProps = {
      className: "",
      large: false,
      small: false,
      title: "Modal title",
      content: "<p>This is a pop-up Modal Component.</p>",
      showClose: true,
      showFooter: false,
      action: null
    };
    
    render(){
      const { large, small, title, content, className, action, showClose, showFooter } = this.props;
      return (
          <div id="myModal" ref="myModal" aria-hidden="true" className={'modal fade '+className} tabIndex="-1" role="dialog">
            <div className={'modal-dialog modal-dialog-centered '+(large?'modal-lg':null)+' '+(small?'modal-sm':null)} role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                  {(showClose)?(
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>):null}
                </div>
                {content?
                <div className="modal-body" dangerouslySetInnerHTML={{ __html: content }}></div>:
                <div className="modal-body">
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>}
                {(showFooter)?(
                <div className="modal-footer">
                  {action}
                </div>):null}
              </div>
            </div>
          </div>
      );
    }
}

export default Modal;

